import * as d3 from "d3";
import $ from 'jquery';
import { addCommas, genderTooltip } from './helpers';
import * as axios from 'axios';

var Chart = (function () {

    var isMobileIsh,
        showPercentage = false,
        sortOrder = showPercentage ? d3.stackOrderDescending : d3.stackOrderReverse,
        margin = { top: 0, right: 100, bottom: 180, left: 10 },
        width = 1000 - margin.left - margin.right,
        height = 610 - margin.top - margin.bottom,
        svg = d3.select("#sot-chart")
            .append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")"),
        g = svg.append('g'),
        segments = g.append('g').attr('class', 'segments'),
        edges = g.append('g').attr('class', 'edges'),
        xAxis = g.append('g').attr('class', 'axis axis--x'),
        yAxis = g.append('g').attr('class', 'axis axis--y'),
        overlay = g.append('rect'),
        focus = g.append('g').attr("class", "focus"),
        segment,
        edge,
        x,
        y,
        color,
        parseDate = d3.timeParse("%Y-%m-%d"),
        area,
        line,
        stack,
        layers = [],
        data = []

    var bisectDate = d3.bisector(function (d) {
        return d.date;
    }).left;

    const pageWidth = window.innerWidth

    const caseData = axios.get("https://docs.google.com/spreadsheets/d/e/2PACX-1vRb8zyDNZXyPrSgwxUxENm2jKPV-ewDJF_CbEGWvCNuYzXZT_6YwCv209lTeyI6tUIL6jRl6ZWD5Dcv/pub?gid=1704181121&single=true&output=csv")
        .then(content => {
            const justData = content.data
            const pop = d3.csvParse(justData)
            init(pop)
        })

    /**
     * init chart
     */
    function init(pop) {

        d3.selectAll(".genderbutton").on("click", function () {

            var selectedVariable = d3.select(this).attr("id");
            if (d3.select(this).classed("selected")) {
            } else {
                d3.selectAll(".genderbutton").classed("selected", false);
                d3.select(this).classed("selected", true);
            }
            if (selectedVariable == 'All') { data = pop } else {
                data = pop.filter(function (d) { return d.sex == selectedVariable })
            }
            update(data)
        })
        d3.select(".charttype")
            .on("click", function () {
                type()
            })

        // grab the selected sex and filter data before calling update()
        let data = pop.filter(function (d) { return d.sex == 'Males' })

        function type() {
            showPercentage = !showPercentage;
            sortOrder = showPercentage ? d3.stackOrderDescending : d3.stackOrderReverse;
            if (event) {
                event.target.textContent = showPercentage ? 'Mostrar porcentaje' : 'Mostrar numero';
            }
            update(data);
        }

        // generate initial graph
        update(pop);

    }

    /**
     * Updates stack, layers, segments and layers on datachange
     */
    function update(pop) {

        pop.forEach((d, i) => {
            d.month = parseDate(d.date);
            d.count = +d.value;
        });

        data = d3.nest()
            .key(d => d.date)
            .key(d => d.group)
            .rollup(v => d3.sum(v, d => d.value))
            .sortKeys(d3.ascending)
            .entries(pop)

        data.forEach((d) => {
            d.date = parseDate(d.key);
            d['En espera de juicio'] = +d.values[5].value;
            d['En espera de prisión estatal'] = +d.values[1].value;
            d['Condenados parcialmente'] = +d.values[4].value;
            d['Total de condenados'] = +d.values[2].value;
            d['En espera de hospitales de salud mental'] = +d.values[0].value;
            d['Revocación de la libertad condicional'] = +d.values[3].value;
        })
        data.sort((a, b) => a.date - b.date)

        var keys = d3.keys(data[0]).filter(function (key) { return key !== 'date' && key != 'key' && key != 'values' && key != 'allpop'; })

        stack = d3.stack()
            .keys(keys)
            .order(d3.stackOrderAscending)
            .offset(d3.stackOffsetExpand);
        if (showPercentage) {
            stack.offset(d3.stackOffsetNone);
        }

        layers = stack(data);
        segment = segments.selectAll('path').data(layers);
        segment.enter()
            .append('path')
            .attr('class', 'segment')
            .merge(segment);
        segment.exit().remove();
        edge = edges.selectAll('path').data(layers);
        edge.enter()
            .append('path')
            .attr('class', 'edge')
            .merge(edge);
        edge.exit().remove();

        color = d3.scaleOrdinal()
            .range(["#FCECA4", "#FFDA00", "#FF9900", "#ef4136", "#b71d93", "#69468e"])

        render();
    }

    /**
     * render
     */
    function render() {

        setDimensions(window.innerWidth);

        x = d3.scaleTime()
            .domain(d3.extent(data, function (d) { return d.date; }))
            .range([0, width]);

        y = d3.scaleLinear()
            .domain([d3.min(layers, stackMin), d3.max(layers, stackMax)])
            .range([height, 0]);

        area = d3.area()
            .x(d => x(d.data.date))
            .y0(d => y(d[0]))
            .y1(d => y(d[1]))

        line = d3.line()
            .x(d => x(d.data.date))
            .y(d => y(d[0]))

        svg.attr('width', (width + margin.left + margin.right))
            .attr('height', (height + margin.top + margin.bottom));

        g.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        // layers
        segments.selectAll('.segment')
            .transition().duration(850).ease(d3.easeCubicInOut)
            .attr('d', function (d) { return area(d); })
            .attr('fill', function (d) { return color(d.index); })

        edges.selectAll('.edge')
            .transition().duration(850).ease(d3.easeCubicInOut)
            .attr('d', line)
            .attr('stroke', '#fff')
            .attr('stroke-width', 1)
            .attr('fill', 'none')

        xAxis.attr('transform', 'translate(0,' + height + ')')
            .call(d3.axisBottom(x).tickFormat(d3.timeFormat("%b %Y")).ticks(5))
            .select('.tick:last-of-type text')
            .attr('dx', -5)
            .style('text-anchor', 'end');

        var formatPercent = d3.format(".0%");

        if (showPercentage) {
            yAxis
                .call(d3.axisLeft(y).ticks(5))
        } else {
            yAxis
                .call(d3.axisLeft(y).ticks(5).tickFormat(formatPercent))
        }

        var legend = svg.selectAll(".legend")
            .data(stack(data))
            .enter()
            .append("g")
            .attr("class", "legend")
            .attr("transform", "translate(" + (0) + "," + (height + 60) + ")");

        legend.append("rect")
            .attr('x', 55)
            .attr("y", (d, i) => i * 20)
            .attr("width", 10)
            .attr("height", 10)
            .style('fill', d => color(d.key))

        legend.append("text")
            .attr("dx", "1.15em")
            .attr('x', 55)
            .attr("y", (d, i) => (i * 20) + 10)
            .attr('font-family', 'GT Walsheim Regular')
            .attr('font-size', 16)
            .text(d => d.key)

        // tooltips

        var mainTooltip = d3.select("body").append("div")
            .attr("class", "mainTooltip");

        focus
            .style("display", "none");

        focus.append("rect")
            .attr('x', -.5)
            .attr('y', 0)
            .attr('width', 1)
            .attr('height', height)
            .attr('fill', '#ccc')

        overlay
            .attr("class", "overlay")
            .attr("width", width)
            .attr("height", height)
            .on("mouseover", function () {
                focus.style("display", null);
            })
            .on("mouseout", function () {
                focus.style("display", "none");
                mainTooltip.style("visibility", "hidden");
            })
            .on("mousemove", mousemove);

        function mousemove() {
            var main_hover = d3.select('.main-hover')
            main_hover.attr("y", event.pageY - 140 + "px").attr('x', 0)

            var x0 = x.invert(d3.mouse(this)[0]),
                i = bisectDate(data, x0, 1),
                d0 = data[i - 1],
                d1 = data[i],
                d = x0 - d0.date > d1.date - x0 ? d1 : d0;

            var formatTime = d3.timeFormat("%m/%d/%Y");

            focus.attr("transform", "translate(" + x(d.date) + "," + 0 + ")");

            const totalPopulation = d.values[0].value + d.values[1].value + d.values[2].value + d.values[3].value + d.values[4].value + d.values[5].value

            const tooltip_str = formatTime(d.date) + '<br/>' +
                "<div class='tooltip-label' style='background:#FCECA4;'></div>En espera de juicio: " + addCommas(d.values[5].value) + ' (' + (((d.values[5].value / totalPopulation) * 100).toFixed(0)) + '%)<br/>' +
                "<div class='tooltip-label' style='background:#FFDA00;'></div>En espera de prisión estatal: " + addCommas(d.values[1].value) + ' (' + (((d.values[1].value / totalPopulation) * 100).toFixed(0)) + '%)<br/>' +
                "<div class='tooltip-label' style='background:#FF9900;'></div>Condenados parcialmente: " + addCommas(d.values[4].value) + ' (' + (((d.values[4].value / totalPopulation) * 100).toFixed(0)) + '%)<br/>' +
                "<div class='tooltip-label' style='background:#ef4136;'></div>Total de condenados: " + addCommas(d.values[2].value) + ' (' + (((d.values[2].value / totalPopulation) * 100).toFixed(0)) + '%)<br/>' +
                "<div class='tooltip-label' style='background:#b71d93;'></div>En espera de hospitales de salud mental: " + addCommas(d.values[0].value) + ' (' + (((d.values[0].value / totalPopulation) * 100).toFixed(0)) + '%)<br/>' +
                "<div class='tooltip-label' style='background:#69468e;'></div>Revocación de la libertad condicional: " + addCommas(d.values[3].value) + ' (' + (((d.values[3].value / totalPopulation) * 100).toFixed(0)) + '%)'

            mainTooltip
                .style('left', (pageWidth - (width + margin.right + margin.left)) / 2 + margin.left + x(d.date) + 'px')
                .style("top", event.pageY - 140 + "px").attr('x', 0)
                .html(tooltip_str)
                .style("visibility", "visible")

        }

        //end tooltips

    }

    function toggle(index) {
        update();
    }

    function sortStack() {
        sortOrder = sortOrder === d3.stackOrderInsideOut ? (showPercentage ? d3.stackOrderDescending : d3.stackOrderReverse) : d3.stackOrderInsideOut;
        update();
    }

    function stackMax(layer) {
        return d3.max(layer, function (d) { return d[1]; });
    }

    function stackMin(layer) {
        return d3.min(layer, function (d) { return d[0]; });
    }

    function setDimensions(window) {
        isMobileIsh = window <= 470;
        if (isMobileIsh) {
            margin = { top: 20, right: 20, bottom: 30, left: 30 };
        } else {
            margin = { top: 30, right: 40, bottom: 150, left: 50 };
        }

    }

    return {
        render: render,
        toggle: toggle,
        sortStack: sortStack
    };

})(window);

genderTooltip()

window.addEventListener('resize', Chart.render);